import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-company-rate-table',
  templateUrl: './company-rate-table.component.html',
  styleUrls: ['./company-rate-table.component.scss']
})
export class CompanyRateTableComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
